import styled, {css} from 'styled-components';

import SupportIcon from '../../../../assets/icons/support.svg';
import {ms} from '../../../../styles/normalizeSize';
import {getAlphaColor, getColor} from '../../../../styles/utils';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

export const Container = styled(View)`
  ${platform.isWeb &&
  css`
    align-self: center;
  `}
`;

export const IconContainer = styled(View)`
  width: ${ms(40)};
  height: ${ms(40)};
  min-width: ${ms(40)};
  min-height: ${ms(40)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${getColor('button.fill2')};
  border-radius: ${ms(50)};
  box-shadow: 0 ${ms(4)} ${ms(20)} ${getAlphaColor('button.fill2', 0.5)};

  ${platform.isWeb &&
  css`
    &:hover {
      background-color: ${getColor('background13')};
      box-shadow: none;
    }
  `}
`;

export const Icon = styled(SupportIcon).attrs(p => ({
  fill: getColor('icon.white')(p),
}))`
  width: ${ms(24)};
  height: ${ms(24)};
`;
